import React from 'react';
import Wrapper from '../layouts/Wrapper';

function HowToTakeTest() {
  return (
    <Wrapper>
      <div className="container">
        <div className="video-container">
          <video
            preload="none"
            autoPlay
            muted
            playsInline
            className="how-take-test"
            controls
          >
            <source src="/video/howTestVideo.mp4" type="video/mp4" />
            <track
              kind="captions"
              src="/video/howTestVideo.mp4"
              srcLang="en"
              label="How take test"
              default
            />
          </video>

        </div>
      </div>
    </Wrapper>
  );
}

export default HowToTakeTest;
